import { render, staticRenderFns } from "./TheProjectCommercialMargin.vue?vue&type=template&id=2db56c5f&"
import script from "./TheProjectCommercialMargin.vue?vue&type=script&lang=js&"
export * from "./TheProjectCommercialMargin.vue?vue&type=script&lang=js&"
import style0 from "./TheProjectCommercialMargin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports